import { FC, ComponentProps, useState, Fragment } from 'react';
import classNames from 'classnames';
import { IonInput, IonIcon, IonButton } from '@ionic/react';

import { ICONS_BASE64 } from '../../Icon';
import { FormControl, FormControlBaseProps } from '../FormControl';

import { FormPasswordValidation } from './FormPassword.types';

import input from '../_styles/input.module.scss';
import styles from './FormPassword.module.scss';

interface FormPasswordProps
  extends FormControlBaseProps<FormPasswordValidation> {
  placeholder?: string;
  enterKeyHint?: ComponentProps<typeof IonInput>['enterkeyhint'];
  autocomplete?: ComponentProps<typeof IonInput>['autocomplete'];
  autocapitalize?: ComponentProps<typeof IonInput>['autoCapitalize'];
}

export const FormPassword: FC<FormPasswordProps> = ({
  disabled,
  autofocus,
  placeholder,
  autocomplete,
  autocapitalize,
  enterKeyHint = 'next',
  ...props
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <FormControl variant="default" type="password" {...props}>
      {({ value = '', onChange, onBlur, invalid, help, error }) => {
        return (
          <Fragment>
            <IonInput
              value={value}
              fill="outline"
              helperText={help}
              onIonBlur={onBlur}
              disabled={disabled}
              label={props.label}
              autofocus={autofocus}
              onIonInput={onChange}
              labelPlacement="stacked"
              placeholder={placeholder}
              errorText={error?.message}
              enterkeyhint={enterKeyHint}
              autocomplete={autocomplete}
              autoCapitalize={autocapitalize}
              type={visible ? 'text' : 'password'}
              className={classNames(input.root, {
                'ion-invalid': invalid,
                'ion-touched': invalid,
              })}
            >
              {!disabled && (
                <IonButton
                  slot="end"
                  fill="clear"
                  size="small"
                  className={styles.button}
                  onClick={() => setVisible((v) => !v)}
                >
                  <IonIcon
                    slot="icon-only"
                    aria-hidden="true"
                    icon={
                      visible ? ICONS_BASE64['eye-off'] : ICONS_BASE64['eye']
                    }
                  />
                </IonButton>
              )}
            </IonInput>
          </Fragment>
        );
      }}
    </FormControl>
  );
};
